import { render, staticRenderFns } from "./VacantJobs.vue?vue&type=template&id=e890b046"
import script from "./VacantJobs.vue?vue&type=script&lang=js"
export * from "./VacantJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports